<!-- FOR WIDTH > 900 PX -->
<button mat-raised-button *ngIf="canSeePrevious" [ngClass] = "[menuExpandContext$.value == true ? 'menuExpandOffset' : '',
menuContextValue? 'previousDesktopButtonWithMenu previousDesktopButton': 'previousDesktopButton']" color="primary" (click)="goBack()">
    <span class="material-icons">
        chevron_left
    </span>
    {{previousText}}
</button>

<button *ngIf="canSeeNext" [ngClass]="canNext  ? 'nextBtn' : 'nextBtn disabledBtn'" mat-raised-button color="primary" (click)="goNext()">
    <span *ngIf="!canNext && nextIconText" class="material-icons iconBtn errorIcon">{{nextIconText}}</span>&nbsp;
    <span *ngIf="!canNext">{{nextText}}</span>
    <span *ngIf="canNext">{{nextTextValid}}</span>&nbsp;
    <span *ngIf="canNext" class="material-icons iconBtn nextIcon">navigate_next</span>
</button>


<!-- FOR WIDTH < 900 PX -->
<div [ngClass] = "menuContextValue? 'InternalMobileNavigationBarWithMenu InternalMobileNavigationBar' : 'InternalMobileNavigationBar'" >
	<span  *ngIf="canSeePrevious" class="leftButton" (click)="goBack()">
		<p><span class="material-icons">
			chevron_left
			</span> {{previousText}}
        </p>
    </span>
    
    <span *ngIf="canSeeNext" (click)="goNext()" [ngClass]="canNext ? 'rightButton' : 'rightButton disabledBtn'">
        <p  *ngIf="!canNext">
            <span *ngIf="nextIconText" class="material-icons iconBtn errorIcon">{{nextIconText}}</span>&nbsp;
            {{nextText}}
        </p>
        <p *ngIf="canNext">
           	{{nextTextValid}}
            <span *ngIf="canNext" class="material-icons iconBtn nextIcon">navigate_next</span>
        </p>     
    </span>

    <span  *ngIf="!canSeePrevious" class="leftButton fakeBtn" >
    </span>
    <span *ngIf="!canSeeNext"  class="rightButton fakeBtn">
    </span>


</div>